module.exports = __webpack_public_path__ + "89a0c137330aea2eb97d54016d4f3920.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/head/bun.png
// module id = 2651
// module chunks = 0